import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import Tabs from './Tabs/Tabs';
import jsPDF from 'jspdf';
import rasterizeHTML from 'rasterizehtml';

class Result extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabs: [],
            positioningData: [],
            ErrorModal: false,
        };
    }
    componentWillMount() {
        let customerSegmentData = {
            projectId: this.props.projectId,
            type: 'segmentation'
        }
        let competeData = {
            projectId: this.props.projectId,
            type: 'compete'
        }
        let positioningStatementData = {
            projectId: this.props.projectId,
            type: 'positioning'
        }
        let cometitorsGroups = {
            projectId: this.props.projectId,
            type: 'competitors'
        }
        let ValueProposition = {
            projectId: this.props.projectId,
            type: 'valueProposition'
        }
        this.props.getPositioningStatement(positioningStatementData);
        this.props.getCompete(competeData);
        this.props.getCustomerSegment(customerSegmentData);
        this.props.getCompetitorsGroups(cometitorsGroups)
        this.props.getValueProposition(ValueProposition)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.valueProposition.valuePropositionFetched && nextProps.valueProposition.valuePropositionData.Items.length > 0 && this.state.tabs.length === 0) {
            this.setState({
                tabs: nextProps.valueProposition.valuePropositionData.Items[0].propositions
            })
        }
    }
    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }
    printPage = () => {
        let html = `<div style='width:"930px";padding: 20px 0px 0px 30px'>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>

                        <br/>
            ${this.state.tabs.map(item => {
                let groupName = ''
                this.props.compete.customerSegmentData.map(comp => {
                    comp.segments.map(segments => {
                        if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                            groupName = comp.groupName + ` - ` + segments.name
                        }
                    })
                })
                return `<div style="margin-bottom: 20px">
                    <div>
                        <div style='width: fit-content;    padding: 10px; margin-bottom: 15px;margin-left: 10px;margin-top: 5px'>
                            <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">${groupName}</a>
                        </div>
                    </div>
                    <div style="width: 700px; padding-bottom: 10px">
                        <table style="width: 49%; float: left" border="1" cellspacing="0" cellpadding="15">
                            <tbody>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: center;">Offer</td>
                                    <td style="width: 40%; font-size: 13px; font-weight: bold; text-align: center;">The Whole Product </td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Core:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.product.offer.core}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Augmented Product:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.product.offer.augmentProduct}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Services:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px; ">${item.product.offer.services}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Information and Consulting:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.product.offer.intPartnership}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style="width: 50%; float: right" border="1" cellspacing="0" cellpadding="15">
                            <tbody>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Price:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.price}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Place:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.place.review1}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Promotion:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.promotion.map(prom => {
                                        return `<span style='margin-left: 10px'>${prom.value}</span>`
                                    })
                                    }</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>`
            }).join('')}
            </div>`;
        let w = window.open();
        w.document.write(html);
        w.print();
        w.close();
    };
    printDocument = (e) => {
        e.preventDefault();
        const canvas = document.createElement('canvas');
        canvas.height = 1000;
        canvas.width = 1500;
        // canvas.textAlign = "center";

        let html = `<div style='width:"930px";padding: 20px 0px 0px 30px'>
                        <h2 style='font-size: 18px; color: #333333; margin: 0px 0px 0px 0px'>Results</h2>
                        <br/>
            ${this.state.tabs.map(item => {
                let groupName = ''
                this.props.compete.customerSegmentData.map(comp => {
                    comp.segments.map(segments => {
                        if (item.groupId === comp.groupId && item.segmentId === segments.segmentId) {
                            groupName = comp.groupName + ` - ` + segments.name
                        }
                    })
                })
                return `<div style="margin-bottom: 20px">
                    <div>
                        <div style='width: fit-content;    padding: 10px; margin-bottom: 15px;margin-left: 10px; margin-top: 5px'>
                            <a style="font-weight: bold; text-shadow: 0px 0px 3px #ddd; color: #000">${groupName}</a>
                        </div>
                    </div>
                    <div style="width: 700px; padding-bottom: 10px">
                        <table style="width: 49%; float: left" border="1" cellspacing="0" cellpadding="15">
                            <tbody>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: center;">Offer</td>
                                    <td style="width: 40%; font-size: 13px; font-weight: bold; text-align: center;">The Whole Product </td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Core:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.product.offer.core}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Augmented Product:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.product.offer.augmentProduct}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Services:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px; ">${item.product.offer.services}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Information and Consulting:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.product.offer.intPartnership}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style="width: 50%; float: right" border="1" cellspacing="0" cellpadding="15">
                            <tbody>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Price:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.price}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Place:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.place.review1}</td>
                                </tr>
                                <tr>
                                    <td style="width: 20%; font-size: 13px; font-weight: bold; text-align: left;">Promotion:</td>
                                    <td style="width: 40%; border: 1px solid #ddd; border-radius: 5px;">${item.promotion.map(prom => {
                                        return `<span style='margin-left: 10px'>${prom.value}</span>`
                                    })
                                    }</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>`
            }).join('')}
            </div>`;
        rasterizeHTML.drawHTML(html, canvas).then((renderResult) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'pt', 'a4');
            pdf.addImage(imgData, 'JPEG', 0, 0);
            pdf.save('value-proposition.pdf');
        });
    }
    downloadPDF = (e) => {
        this.printDocument(e);
    }
    render() {
        return (
            <div className='criteria-content'>
                <div className='step-bar'>
                    <div className='step step-five arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-five arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-five arrow-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-five arrow-step active-step'>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                      <div className="col-sm-12">
                        <h5>Value Proposition</h5>
                      </div>
                    </div>
                    {(this.props.compete.competeFetching || !this.props.positioningStatement.getPositioningStatementFetched || this.props.compete.competitorsGroupsFetching || !this.props.valueProposition.valuePropositionFetched || !this.props.compete.customerSegmentFetched || this.props.valueProposition.createValuePropositionPending) && this.elementInfiniteLoad()}
                    {!this.props.compete.competeFetching && this.props.positioningStatement.getPositioningStatementFetched && !this.props.compete.competitorsGroupsFetching && this.props.valueProposition.valuePropositionFetched && this.props.compete.customerSegmentFetched &&
                        <div className='row'>
                            <div className="col-md-12">
                                <div className='card'>
                                    <div className="card-header">
                                      <div className="col-md-8">
                                        <div className="criteria-title-box">
                                            <h5>Results</h5>
                                        </div>
                                      </div>
                                    </div>
                                    <div className='card-body'>
                                        <Tabs
                                            tabs={this.state.tabs}
                                            compete={this.props.compete}
                                            positioningStatement={this.props.positioningStatement.getPositioningStatementData.Items[0].positioning}
                                            tabStep={this.props.tabStep}
                                            onTabChange={this.props.onTabChange}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className='card'>
                                    <div className='card-body'>
                                        {/* <div className='btn btn-success' onClick={() => this.onNextButtonClick()}>Next</div> */}
                                        <Link to={'/pricing-value/'+this.props.projectId} className='btn btn-success'> Next </Link>
                                        <Link to='/toolkit' className='btn btn-success'> Done </Link>
                                        <div className='btn empty-btn default' onClick={this.downloadPDF}>Save PDF</div>
                                        <div className='btn empty-btn default' onClick={this.printPage}>Print</div>
                                        <div className='btn empty-btn default' onClick={() => this.props.groupStateBack()}>Back</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default (Result);



// WEBPACK FOOTER //
// ./src/components/ValuePropositionComponent/Result/Result.jsx